    
export const onlySuperAdmin = ['SuperAdmin']
export const AllRole = ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Operatore', 'Supervisore', 'Consulente', 'Speaker', 'Montatore']
export const AllRoleNoOperatore = ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Supervisore', 'Consulente', 'Speaker', 'Montatore'];
export const ListInterviewRole = ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Consulente', 'Speaker', 'Montatore'];
export const SuperAndAdmin = ['SuperAdmin', 'Admin'];
export const SuperAndAdvance = ['SuperAdmin', 'AdvancedAdmin'];
export const SuperAndAdminAdvance = [...SuperAndAdvance, 'Admin'];
export const SuperAndAdminConsulente = ['SuperAdmin', 'Admin', 'AdvancedAdmin',  "Consulente"];
export const SuperAdminVisore= ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Supervisore'];
export const SuperAdminVisoreOpe= ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Supervisore', 'Operatore'];
export const SuperAdminVisoreOpeCons= ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Supervisore', 'Operatore', 'Consulente'];


export const InterviewMont = ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Montatore'];
export const InterviewSpeack = ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Speaker'];
export const IntervieAdmin = ['SuperAdmin', 'Admin']
export const IntervieCons= ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Consulente'];
export const IntervieSpeak= ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Consulente', 'Speaker'];

export const HostListRoleForm = ['SuperAdmin', 'Admin', 'AdvancedAdmin', 'Operatore', 'Supervisore', 'Consulente', 'Speaker'];

export const ReportsViewRoleAdmin = ['SuperAdmin', 'Admin', 'AdvancedAdmin'];
